// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"72":"thanks","171":"webinar"}[chunkId] + "." + {"72":"e304f244","171":"e6ccdeeb"}[chunkId] + ".css";
};